import { Tooltip } from '@material-ui/core';
import CSS from 'csstype';
import React from 'react';

import { FONT_WEIGHT } from '~/src/dash/components/text/common';
import {
  SimpleTextToggleSize,
  simpleTextToggleSizeStyle,
} from '~/src/dash/components/toggles/common';
import { publicaColors } from '~/src/dash/utils/colors';

interface IProps {
  active: boolean;
  children?: any;
  className?: string;
  disabled?: boolean;
  onClick: (props?: any | null) => void;
  size?: SimpleTextToggleSize;
  style?: CSS.Properties;
  tooltipText?: string;
  value?: string; // using this will nullify children
}

export const SimpleTextToggle = ({
  active,
  children,
  className = '',
  disabled,
  onClick,
  size = 'base',
  style,
  tooltipText = '',
  value,
}: IProps) => {
  return (
    <Tooltip title={tooltipText} placement='top'>
      <button
        onClick={disabled ? () => null : onClick}
        className={className}
        style={{
          display: 'inline-block',
          borderWidth: 0,
          lineHeight: 'inherit',
          fontFamily: 'inherit',
          fontStyle: 'inherit',
          fontWeight: active ? FONT_WEIGHT.bold : FONT_WEIGHT.base,
          whiteSpace: 'nowrap',
          margin: 0,
          backgroundColor: active ? publicaColors.lightGray : 'inherit',
          color: active ? publicaColors.black : publicaColors.gray,
          opacity: disabled ? 0.4 : 1,
          cursor: disabled ? 'not-allowed' : 'pointer',
          minWidth: '40px',
          textAlign: 'center',
          ...simpleTextToggleSizeStyle(size),
          ...style,
        }}
      >
        {value || children}
      </button>
    </Tooltip>
  );
};
